import React from 'react';
import { Button } from './ui/Button';
export function NavBar() {
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-base/90 backdrop-blur-md border-b border-border-muted" data-id="element-418">
      <div className="max-w-7xl mx-auto px-4 md:px-6 h-12 flex items-center justify-between gap-4" data-id="element-419">
        {/* Left — brand mark */}
        <span className="font-display text-sm font-bold text-text-primary tracking-wide hidden md:block" data-id="element-420">
          TVTCS
        </span>

        {/* Center — urgency strip */}
        <div className="flex items-center gap-2 md:gap-3 mx-auto md:mx-0 md:flex-1 md:justify-center" data-id="element-421">
          <span className="font-mono text-[10px] text-accent-primary" data-id="element-422">◆</span>
          <span className="font-ui text-[10px] md:text-xs font-semibold tracking-widest uppercase text-accent-primary" data-id="element-423">
            Limited Memorial Edition
          </span>
          <span className="font-mono text-[10px] text-accent-primary" data-id="element-424">◆</span>
        </div>

        {/* Right — CTA */}
        <Button href="#offer" variant="secondary" className="hidden md:inline-flex !text-xs !px-4 !py-1.5 !tracking-wider" data-id="element-425">
          Get It Now
        </Button>
      </div>
    </nav>;
}